import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "headerWrap"
};
const _hoisted_2 = {
  class: "leftwrap"
};
const _hoisted_3 = {
  class: "leftcon1"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "leftcon2"
};
const _hoisted_6 = {
  class: "screenbtn"
};
const _hoisted_7 = {
  class: "rightwrap"
};
const _hoisted_8 = {
  class: "rightcon2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Monitor = _resolveComponent("Monitor");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Iphone = _resolveComponent("Iphone");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($props.mapform.title), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "line"
  }, null, -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
    class: "icon icon-narrow",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.increase && $options.increase(...args))
  }), _createElementVNode("span", null, _toDisplayString($data.percentage) + "%", 1), _createElementVNode("i", {
    class: "icon icon-enlarge",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.decrease && $options.decrease(...args))
  })])]), _createElementVNode("ul", _hoisted_6, [_createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = $event => $options.screenswitch(0)),
    class: _normalizeClass({
      'on': $data.screenIndex === 0
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Monitor)]),
    _: 1
  })], 2), _createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = $event => $options.screenswitch(1)),
    class: _normalizeClass({
      'on': $data.screenIndex === 1
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Iphone)]),
    _: 1
  })], 2)]), _createElementVNode("div", _hoisted_7, [_cache[7] || (_cache[7] = _createElementVNode("ul", {
    class: "rightcon1"
  }, [_createElementVNode("li", null, [_createElementVNode("i", {
    class: "icon icon-revoke"
  }), _createElementVNode("span", null, "撤销")]), _createElementVNode("li", null, [_createElementVNode("i", {
    class: "icon icon-recovery"
  }), _createElementVNode("span", null, "恢复")])], -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "line"
  }, null, -1)), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
    plain: "",
    onClick: $options.previewmap
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("预览")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    plain: "",
    onClick: $options.saveHandle
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("保存")])),
    _: 1
  }, 8, ["onClick"])])])]);
}